import React from 'react';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';
import scheduleFormStyles from '../../../stylesheets/management_site/scheduleForm.module.scss';
import classNames from 'classnames';

const ScheduleAdvanceSettings = ({
  fieldPrefix,
  initialData,
  daysAdvanceType,
  setDaysAdvanceType,
  parsedChargeDate = null,
}) => {
  const parsedChargeDateType = parsedChargeDate?.type;

  return (
    <div className={newLeaseModalStyles.scheduleAdvanceSection}>
      <div className={newLeaseModalStyles.sectionHeader}>
        <h3 className={newLeaseModalStyles.sectionTitle}>
          Generate Charge in Advance
        </h3>
      </div>
      <div className={newLeaseModalStyles.sectionContent}>
        <div
          className={classNames(
            'schedule-days-advance-container',
            'pm-flex',
            'pm-flex-col',
            newLeaseModalStyles.noMarginBottom
          )}
        >
          <div
            className={classNames(
              'pm-flex',
              'pm-align-center',
              'pm-margin-bottom-10',
              'pm-form-multi',
              scheduleFormStyles.radioOptionGap,
              {
                [scheduleFormStyles.selected]: daysAdvanceType === 'relative',
                [scheduleFormStyles.notSelected]:
                  daysAdvanceType !== 'relative',
              }
            )}
          >
            <div className="mdc-form-field">
              <div className="mdc-radio">
                <input
                  type="radio"
                  className="mdc-radio__native-control schedule-days-advance-type-radio"
                  name={`${fieldPrefix}[days_advance_generate_charge_type]`}
                  value="relative"
                  checked={daysAdvanceType === 'relative'}
                  onChange={() => setDaysAdvanceType('relative')}
                />
                <div className="mdc-radio__background">
                  <div className="mdc-radio__outer-circle"></div>
                  <div className="mdc-radio__inner-circle"></div>
                </div>
              </div>
            </div>
            <div
              className={classNames(
                'mdc-form-field',
                'mdc-form-field--align-end',
                scheduleFormStyles.frequencySelectContainer
              )}
            >
              <div
                data-mdc-auto-init="MDCTextField"
                className={classNames(
                  'mdc-text-field',
                  'pm-large',
                  scheduleFormStyles.scheduleTextInput
                )}
              >
                <input
                  type="text"
                  id="days-advance-field-1"
                  className="mdc-text-field__input days-advance-field"
                  name={`${fieldPrefix}[days_advance_generate_charge]`}
                  defaultValue={
                    parsedChargeDateType === 'offset'
                      ? parsedChargeDate.offsetDays?.toString()
                      : initialData.daysAdvanceGenerateCharge
                  }
                  disabled={daysAdvanceType !== 'relative'}
                />
                <label
                  htmlFor="days-advance-field-1"
                  className="mdc-floating-label"
                >
                  Relative days in advance
                </label>
              </div>
            </div>
          </div>
          <div
            className={classNames(
              'pm-flex',
              'pm-align-center',
              'pm-form-multi',
              scheduleFormStyles.radioOptionGap,
              {
                [scheduleFormStyles.selected]: daysAdvanceType === 'fixed',
                [scheduleFormStyles.notSelected]: daysAdvanceType !== 'fixed',
              }
            )}
          >
            <div className="mdc-form-field">
              <div className="mdc-radio">
                <input
                  type="radio"
                  className="mdc-radio__native-control schedule-days-advance-type-radio"
                  name={`${fieldPrefix}[days_advance_generate_charge_type]`}
                  value="fixed"
                  checked={daysAdvanceType === 'fixed'}
                  onChange={() => setDaysAdvanceType('fixed')}
                />
                <div className="mdc-radio__background">
                  <div className="mdc-radio__outer-circle"></div>
                  <div className="mdc-radio__inner-circle"></div>
                </div>
              </div>
            </div>
            <div
              className={classNames(
                'mdc-form-field',
                'mdc-form-field--align-end',
                scheduleFormStyles.frequencySelectContainer
              )}
            >
              <div
                className={classNames(
                  'pm-select',
                  'pm-relative',
                  'pm-selectlabel',
                  scheduleFormStyles.fixedDaySelect
                )}
              >
                <label className="pm-selectlabel-text">
                  Fixed day of month
                </label>
                <select
                  id="days-advance-field-2"
                  className={classNames(
                    'pm-default-select2-menu',
                    'mdc-select',
                    'pm-select-medium',
                    'days-advance-field'
                  )}
                  name={`${fieldPrefix}[days_advance_generate_charge]`}
                  defaultValue={
                    parsedChargeDateType === 'fixedDay'
                      ? parsedChargeDate.dayOfMonth?.toString()
                      : initialData.daysAdvanceGenerateCharge
                  }
                  disabled={daysAdvanceType !== 'fixed'}
                >
                  {Array.from({ length: 28 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleAdvanceSettings;
